import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {}
